import React from "react";
import { NavLink } from "react-router-dom";

import "./Footer.css";

import {
  Mail,
  Phone,
  MapPin,
  ArrowRight,
} from "lucide-react";

import {
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaGithub,
} from "react-icons/fa";


const Footer = () => {

  return (

    <footer className="footer">

      {/* ================================================= */}
      {/* BACKGROUND GLOWS */}
      {/* ================================================= */}

      <div className="footer-glow footer-glow-1"></div>
      <div className="footer-glow footer-glow-2"></div>


      <div className="footer-container">

        {/* ================================================= */}
        {/* TOP CTA */}
        {/* ================================================= */}

        <div className="footer-top">

          <div>

            <p className="footer-top-label">
              LET’S BUILD SOMETHING AMAZING
            </p>

            <h2 className="footer-top-title">
              Ready To Scale Your Business?
            </h2>

          </div>


          <NavLink
            to="/contact?service=consultation"
            className="footer-top-btn"
          >

            Book Free Consultation

            <ArrowRight size={18} />

          </NavLink>

        </div>


        {/* ================================================= */}
        {/* FOOTER GRID */}
        {/* ================================================= */}

        <div className="footer-grid">

          {/* ================================================= */}
          {/* COMPANY */}
          {/* ================================================= */}

          <div className="footer-column footer-brand">

            <h3>
              Bairagi Consultants
            </h3>

            <p>

              We build scalable AI-powered software
              systems, ecommerce platforms, mobile
              applications and enterprise dashboards
              for modern businesses.

            </p>


            {/* ============================================= */}
            {/* SOCIAL ICONS */}
            {/* Add actual profile URLs later */}
            {/* ============================================= */}

            <div
              className="footer-socials"
              aria-label="Bairagi Consultants social profiles"
            >

              <span
                className="footer-social-icon"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <FaLinkedinIn />
              </span>

              <span
                className="footer-social-icon"
                aria-label="Instagram"
                title="Instagram"
              >
                <FaInstagram />
              </span>

              <span
                className="footer-social-icon"
                aria-label="Facebook"
                title="Facebook"
              >
                <FaFacebookF />
              </span>

              <span
                className="footer-social-icon"
                aria-label="GitHub"
                title="GitHub"
              >
                <FaGithub />
              </span>

            </div>

          </div>


          {/* ================================================= */}
          {/* SOLUTIONS */}
          {/* ================================================= */}

          <nav
            className="footer-column footer-solutions"
            aria-label="Software solutions"
          >

            <h4>
              Solutions
            </h4>


            <NavLink to="/ecommerce-development">
              Ecommerce Development
            </NavLink>


            <NavLink to="/mobile-app-development">
              Mobile App Development
            </NavLink>


            <NavLink to="/crm-software-development">
              CRM Software Development
            </NavLink>


            <NavLink to="/ai-software-solutions">
              AI Software Solutions
            </NavLink>


            <NavLink to="/custom-dashboard-development">
              Dashboard Development
            </NavLink>

          </nav>


          {/* ================================================= */}
          {/* TECHNOLOGIES */}
          {/* ================================================= */}

          <div className="footer-column footer-technologies">

            <h4>
              Technologies
            </h4>

            <span>React.js</span>

            <span>Next.js</span>

            <span>FastAPI</span>

            <span>PostgreSQL</span>

            <span>Docker</span>

            <span>AWS Cloud</span>

          </div>


          {/* ================================================= */}
          {/* CONTACT */}
          {/* ================================================= */}

          <div className="footer-column">

            <h4>
              Contact
            </h4>


            {/* EMAIL */}

            <a
              href="mailto:bairagiconsultants@gmail.com"
              className="footer-contact"
            >

              <Mail size={16} />

              <span>
                bairagiconsultants@gmail.com
              </span>

            </a>


            {/* PHONE */}

            <a
              href="tel:+919432169467"
              className="footer-contact"
            >

              <Phone size={16} />

              <span>
                +91 9432169467
              </span>

            </a>


            {/* LOCATION */}

            <div className="footer-contact">

              <MapPin size={16} />

              <span>
                Kolkata, India
              </span>

            </div>

          </div>

        </div>


        {/* ================================================= */}
        {/* BOTTOM */}
        {/* ================================================= */}

        <div className="footer-bottom">

          <p>
            © 2026 Bairagi Consultants. All rights reserved.
          </p>


          <nav
            className="footer-bottom-links"
            aria-label="Footer navigation"
          >

            <NavLink to="/">
              Home
            </NavLink>


            <NavLink to="/about">
              About
            </NavLink>


            <NavLink to="/case-studies">
              Case Studies
            </NavLink>


            <NavLink to="/blog">
              Blog
            </NavLink>


            <NavLink to="/contact">
              Contact
            </NavLink>

          </nav>

        </div>

      </div>

    </footer>

  );

};

export default Footer;